<template>
 <div class="app-container">
  <SearchCollapse @update-height="getHeight" :formItemsLength="11">
   <div class="formBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
          <el-form-item label="申请流水:" class="item1">
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.sqls" ></el-input>
          </el-form-item>
          <el-form-item label="运单编号:" class="item1">
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.ydh" ></el-input>
          </el-form-item>
         <el-form-item label="申请时间:" class="item2" >
          <el-date-picker
              v-model="searchFrom.createTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="开票时间:" class="item2" >
          <el-date-picker
              v-model="searchFrom.invoiceTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
         <el-form-item label="审核状态:">
          <el-select v-model="searchFrom.auditStatus"   placeholder="请选择" >
            <el-option label="全部" value="" ></el-option>
            <el-option label="待审核" value="0" ></el-option>
            <el-option label="审核通过" value="1" ></el-option>
            <el-option label="审核驳回" value="2" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票状态:">
          <el-select v-model="searchFrom.status"   placeholder="请选择" >
            <el-option label="全部" value="" ></el-option>
            <el-option label="待开票" value="0" ></el-option>
            <el-option label="已开票" value="1" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算客户:">
          <el-input placeholder="" v-model="searchFrom.payer" ></el-input>
        </el-form-item>
        <el-form-item label="发票编号:">
          <el-input placeholder="" v-model="searchFrom.invoiceNo" ></el-input>
        </el-form-item>
        <el-form-item label="申请公司:">
          <el-select v-model="searchFrom.createSubcompanyName" filterable clearable placeholder="请选择" @change="zigsChangeCX">
            <el-option v-for="item in zigongsiList" :label="item.companyName" :value="item.companyName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
       <el-form-item label="申请部门:" >
          <el-select  v-model="searchFrom.createSubdepartmentName" filterable placeholder="请选择" >
            <el-option  label="全部" value="" ></el-option>
            <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人:">
          <el-input placeholder="" v-model="searchFrom.createUser" ></el-input>
        </el-form-item>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"  size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[10]" size="mini" @click="wzdkpFn">无账单开票</el-button>
            <el-button type="primary" v-if="btnFlg[9]" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
            <el-button type="primary"  v-if="btnFlg[1]"   size="mini" @click="chexiaoSQFN">撤销申请</el-button>
            <el-button type="primary" v-if="btnFlg[2]" size="mini" @click="chexiaoKPFn">撤销开票</el-button>
            <el-button type="primary"  size="mini" v-if="btnFlg[3]" @click="xgkpsjFn">修改开票时间</el-button>
            <el-button type="primary"  size="mini"  v-if="btnFlg[4]" @click="plkpFn">批量开票</el-button>
          </div>
        </div>
      </el-form>
    </div>
    </SearchCollapse>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"  class="tableComent"  bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <div>
              <!-- 无账单开票 -->
              <span v-if="scope.row.billInvoiceFlag==1">
                <el-button type="text" size="mini"  v-if="btnFlg[11]&&scope.row.businessStatus =='0'" @click="glzdFN(scope.row)">关联账单</el-button>
                <el-button type="text" size="mini"  v-if="btnFlg[12]&&scope.row.businessStatus =='1'" @click="cxglFN(scope.row)">撤销关联</el-button>
                 <el-button type="text" size="mini"  v-if="btnFlg[8]&&scope.row.businessStatus =='0'" @click="wzdDelFn(scope.row)">删除</el-button>
              </span>
               <span v-else>
                <el-button type="text" size="mini"  v-if="scope.row.status===0&&scope.row.auditStatus==1&&btnFlg[5]" @click="kaipiaoFn(scope.row)">开票</el-button>
                <el-button type="text" size="mini"  v-if="scope.row.auditStatus===0&&btnFlg[6]" @click="tongguoFn(scope.row)">通过</el-button>
                <el-button type="text" size="mini"  v-if="scope.row.auditStatus===0&&btnFlg[6]" @click="bohuiFn(scope.row)">驳回</el-button>
                <el-button type="text" size="mini"  v-if="scope.row.auditStatus==2&&btnFlg[8]" @click="delFN(scope.row)">删除</el-button>
               </span>
               <el-button type="text" size="mini" style="margin-left:8px"  v-if="btnFlg[7]" @click="fujianFN(scope.row)">附件</el-button>

            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="申请流水" align="center" width="160">
          <template slot-scope="scope">
            <el-tooltip effect="dark" :content="scope.row.applyNo" placement="right-end">
              <el-button type="text" @click="detilsFn(scope.row)">{{scope.row.applyNo}}</el-button>
              <div slot="content" style="cursor: pointer;" @click="copyBtn(scope.row.applyNo)">复制</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column property="status" label="开票状态"  width="100" >
          <template scope="scope">
            <div>
              <span  style="color: #F56C6C;" v-if="scope.row.status===0">待开票</span>
              <span  style="color: #67C23A;" v-else-if="scope.row.status==1">已开票</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="auditStatus" label="审核状态"  width="100" >
          <template scope="scope">
            <div>
              <span  style="color: #F56C6C;" v-if="scope.row.auditStatus===0">待审核</span>
              <span  style="color: #67C23A;" v-else-if="scope.row.auditStatus==1">审核通过</span>
              <span  style="color: #E6A23C;" v-else-if="scope.row.auditStatus==2">审核驳回</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="businessStatus" label="业务状态"  width="100" >
          <template scope="scope">
            <div>
              <span  style="color: #F56C6C;" v-if="scope.row.businessStatus=='1'">已完成</span>
              <span  style="color: #F56C6C;" v-if="scope.row.businessStatus=='0'">未完成</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payer" label="结算客户" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="wayNumber" label="运单数量" align="center"
          min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="revenueAmount" label="运单收入总额(元)" width="140"
          align="center">
          <template scope="scope">
            <div>
              {{scope.row.revenueAmount/100|moneyFormatNew}}
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="invoiceAmount" label="发票金额(元)" width="120"
          align="center">
          <template scope="scope">
            <div>
              {{scope.row.pendingAmount/100|moneyFormatNew}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="timeoutWarning" label="超时预警"  width="100" >
          <template scope="scope">
            <div>
              <span v-if="scope.row.timeoutWarning=='1'">正常</span>
              <span  style="color: #F56C6C;" v-if="scope.row.timeoutWarning=='2'">开票超时</span>
            </div>
          </template>
        </el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="timeoutDuration" label="超时时长" align="center" :formatter="formatterRowEmpty"
          width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createSubcompanyName" label="申请公司" align="center"
          width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createSubdepartmentName" label="申请部门" align="center"
          width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="申请人" align="center"
             min-width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" :formatter="dateTimeFormat" label="申请时间"  align="center"
              width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="申请备注" align="center"
             min-width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="invoiceNo" label="发票编号" align="center"
             min-width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="invoiceUser" label="开票人" align="center"
             min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="invoiceTime" :formatter="dateTimeFormat" label="开票时间" align="center"
             min-width="180"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="rejectionTime" :formatter="dateTimeFormat" label="审核时间" align="center"
             min-width="180"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="rejectionRemark" label="驳回原因" align="center"
               min-width="200"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 修改开票时间 -->
    <el-dialog  title="修改开票时间" :close-on-click-modal="false" :close-on-press-escape="false"  @close="kpsjFlag = false"  :visible.sync="kpsjFlag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="kpsjForm" :model="kpsjForm"  class="demo-form-inline"  label-width="110px"  size="mini"  >
          <el-form-item label="开票时间:" prop="invoiceTime" >
              <el-date-picker
                v-model="kpsjForm.invoiceTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
                type="datetime"
                placeholder="选择日期时间"
              ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="kpsjFlag = false">取 消</el-button>
        <el-button type="primary" @click="KPSJsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 驳回 -->
    <el-dialog  title="驳回" :close-on-click-modal="false" :close-on-press-escape="false"  @close="BHflag = false"  :visible.sync="BHflag" width="400px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="BHform" :model="BHform"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="驳回原因" class="item1" prop="rejectionRemark">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="BHform.rejectionRemark" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BHflag = false">取 消</el-button>
        <el-button type="primary" @click="BHsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 流水详情 -->
     <el-dialog title="运单详情" :visible.sync="YDXQmark" :close-on-click-modal="false" width="70%" center >
      <div class="addressBox">
        <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
          <el-form-item label="业务类型:">
            <el-select v-model="yewuliexing"   placeholder="请选择" size="mini" >
                <el-option  label="全部" value="" ></el-option>
                <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary"  size="mini" @click="YDsearchFn">查询</el-button>
          <el-button type="primary"   size="mini" @click="yewuliexing=''">重置</el-button>
        </el-form>
        <el-table :data="yunDanList" ref="yunDanList" height="560px" border size="mini" style="" :header-cell-style="{background:'#F5F5F5',color:'black'}"
         show-summary  :summary-method="getSummary"  >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column prop="wayNo" label="运单号" align="center" width="230"></el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" align="center" width="130">
          </el-table-column>
          <el-table-column prop="liquidatedAmountName" label="结算量" align="center" width="120"  :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="measuringUnit" label="单位" align="center" width="120"  :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="revenueValuationName" label="收入方式" width="100" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="" label="收入单价" width="130">
            <template scope="scope">
              <div>
                <span v-if="scope.row.revenueValuation == '0'">{{scope.row.incomeUnitPrice}}元/吨</span>
                <span v-if="scope.row.revenueValuation == '1'">
                  <span v-if="scope.row.incomeUnitPrice != 0">{{scope.row.incomeUnitPrice}}元/车</span>
                  <span v-else>-</span>
                </span>
                <span v-if="scope.row.revenueValuation == '2'">{{scope.row.incomeUnitPrice}}元/方</span>
                <span v-if="scope.row.revenueValuation == '3'">{{scope.row.incomeUnitPrice}}元/件</span>
                <span v-if="scope.row.revenueValuation == '' || scope.row.revenueValuation == null">-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="incomeAmount"  :formatter="formatterRowEmpty" label="收入金额(元)" width="110">
          </el-table-column>
          <el-table-column prop="revenueSurcharge" :formatter="formatterRowEmpty" label="收入附加费(元)" width="130">
          </el-table-column>
          <el-table-column prop="grossRevenue"  :formatter="formatterRowEmpty" label="收入总额(元)" width="110">
          </el-table-column>
          <el-table-column prop="ysPaymentAmount"  :formatter="formatterRowEmpty" label="已收款金额(元)" width="130">
          </el-table-column>
          <el-table-column prop="ysNoPaymentAmount"  :formatter="formatterRowEmpty" label="未收款金额(元)" width="130">
          </el-table-column>
          <el-table-column prop="ysInvoiceAmount"  :formatter="formatterRowEmpty" label="已开票金额(元)" width="130">
          </el-table-column>
          <el-table-column prop="ysNoInvoiceAmount"  :formatter="formatterRowEmpty" label="未开票金额(元)" width="130">
          </el-table-column>
           <el-table-column prop="wayBusinessTypeName" label="业务类型" width="240" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="generalCarrier" label="承运方" width="240" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="plateNumber" label="车牌号" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="driverPhone" label="司机电话" width="120" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="makeTicketYn" label="是否开票" width="100" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="ysSettlementBillNo" label="账单号" width="200" :formatter="formatterRowEmpty">
          </el-table-column>
          <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
          <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini"  v-if="rowData.auditStatus===0&&btnFlg[6]" @click="tongguoFn(rowData)">通过</el-button>
        <el-button type="primary" size="mini"  v-if="rowData.auditStatus===0&&btnFlg[6]" @click="bohuiFn(rowData)">驳回</el-button>
        <el-button @click="YDXQmark=false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 开票 -->
    <el-dialog title="开票" :visible.sync="kaiPiaoMark" :close-on-click-modal="false" width="1050px" center >
      <div class="addressBox">
        <div style="width:90%;margin:0 auto;">
          <el-form :inline="true" :rules="rules"  :model="kaiPiaoFrom" ref="kaiPiaoFrom" class="demo-form-inline " label-width="100px" size="small">
            <div class="kaip">
               <el-form-item label="开票金额:">
                  <span style="color:red;font-size:18px;margin-right:5px;">{{kaiPiaoFrom.invoiceAmount|moneyFormatNew}}</span><span>元</span>
                </el-form-item>
                <!-- <el-form-item label="发票号码:" prop="invoiceNo">
                  <el-input placeholder="" maxlength="50" v-model.trim="kaiPiaoFrom.invoiceNo"   ></el-input>
                </el-form-item> -->
                <el-form-item label="开票时间:" prop="invoiceTime" >
                  <el-date-picker
                    v-model="kaiPiaoFrom.invoiceTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="timestamp"
                    placeholder="选择日期时间">
                  </el-date-picker>
                </el-form-item>
            </div>
            <el-form-item label="发票二维码:" v-if="kaiPiaoMark" class="is-required">
                <el-radio-group v-model="moban"   >
                  <el-radio label="发票二维码（有销售方）">新模板(有销售方)</el-radio>
                  <el-radio label="发票二维码">旧模板(无销售方)</el-radio>
                </el-radio-group>
                <el-button type="primary" style="margin-left:416px" @click="addRWMFn">新增</el-button>
            </el-form-item>
            <el-table :data="kaiPiaoFrom.ewmList"  ref="tableRWM"   bordersize="mini"  style="width: 100%" max-height="500px"  center border>
              <el-table-column type="index"  label="序号" width="60"></el-table-column>
              <el-table-column label="发票二维码图片"  min-width="120">
                <template slot="header" >
                  <div><span class="red" >*</span>发票二维码图片</div>
                </template>
                <template slot-scope="scope">
                  <div>
                   <uploadImgs :imgList.sync='kaiPiaoFrom.ewmList[scope.$index].lookimgList'  v-if="kaiPiaoMark" :key="scope.row.key"   @change="change($event,scope.$index)">
                      <i class="el-icon-upload"></i>
                    </uploadImgs>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="发票号码"  min-width="120">
                <template slot="header" >
                  <div><span class="red" >*</span>发票号码</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'ewmList.' +scope.$index+ '.fphm'" :key="scope.$index" :rules="rules.invoiceNo"  class="table_error">
                      <el-input placeholder="" maxlength="30" style="width:250px"
                        v-model.trim="kaiPiaoFrom.ewmList[scope.$index].fphm"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="发票金额(元)"  min-width="90">
                <template slot="header" >
                  <div><span class="red" >*</span>发票金额(元)</div>
                </template>
                <template slot-scope="scope">
                  <div>
                    <el-form-item label="" :prop="'ewmList.' +scope.$index+ '.fpje'" :key="scope.$index" :rules="rules.fpje"  class="table_error">
                      <el-input placeholder="" maxlength="10" v-number-input.float="2" style="width:150px"
                        v-model.trim="kaiPiaoFrom.ewmList[scope.$index].fpje"></el-input>
                    </el-form-item>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作"  width="100">
                <template slot-scope="scope">
                  <div>
                    <el-button type="text" size="mini" @click="delewmFn(scope.$index)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <span style="padding: 14px 0;display: inline-block;color:#e6a23c;">至少上传1张发票二维码图片，最多上传10张</span>
            <br>
            <el-form-item label="发票附件:" v-if="kaiPiaoMark" >
              <uploadFiles style="width:300px;" :fileArr.sync='imgList' :max='10' v-if="kaiPiaoMark"></uploadFiles>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="kaiPiaoMark=false">取 消</el-button>
        <el-button type="primary" @click="kaiPiaoSubmitFn('kaiPiaoFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 附件-->
    <el-dialog  title="附件" :close-on-click-modal="false" :close-on-press-escape="false"  @close="FJflag = false"  :visible.sync="FJflag" width="850px" center>
      <div style="display:flex;">
        <div style="width:32%">
          <p>申请开票附件:</p>
          <div class="fujianBox" v-if="SQfujianList.length>0">
             <template  v-for="item in SQfujianList" >
              <el-image  :src="item.url"  v-if="item.isImg"   :preview-src-list="[item.url]"  :key="item.id"> </el-image>
              <el-button type="text" @click="fujianClick(item)"  v-else :key="item.id" style="margin-left: 10px;">{{item.name}}</el-button>
            </template>
          </div>
          <div v-else>
            暂无附件
          </div>
        </div>
        <div  style="width:32%">
          <p>发票二维码:</p>
          <div v-if="RWMimgList.length>0">
             <el-image  v-for="(item,index) in RWMimgList" :src="item" :preview-src-list="RWMimgList.slice(index).concat(RWMimgList.slice(0, index))"  :key="item.id"> </el-image>
          </div>
          <div v-else>
            暂无图片
          </div>
        </div>
        <div style="width:32%">
          <p>发票附件:</p>
          <div class="fujianBox" v-if="fujianList.length>0">
            <template  v-for="item in fujianList" >
              <el-image  :src="item.url"  v-if="item.isImg"   :preview-src-list="[item.url]"  :key="item.id"> </el-image>
              <el-button type="text" @click="fujianClick(item)"  v-else :key="item.id" style="margin-left: 10px;">{{item.name}}</el-button>
            </template>
          </div>
          <div v-else>
            暂无附件
          </div>
        </div>
        <el-dialog  title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
          append-to-body width="800px" center>
          <div style="text-align: right;">
            <div id="printMe"  ref="print">
              <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
            </div>
          </div>
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="FJflag = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 批量开票 -->
   <PLkiapiao v-if="plkpFlag"   :plkpFlag.sync='plkpFlag'></PLkiapiao>
    <!-- 无账单开票 -->
   <WZDkaipiao v-if="wzdkpFlag"   :wzdkpFlag.sync='wzdkpFlag'></WZDkaipiao>
    <!-- 关联账单 -->
   <guanlianzhangdan v-if="glzdFlag" :rowData="rowData"  :glzdFlag.sync='glzdFlag'></guanlianzhangdan>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getInvoiceRecordApplyList, delInvoiceRecordApply, findWayBusinessList, ocrCustomModelByFile, ocrModelList, getDictionaryDetailList,
  confirmInvoiceApply, getFileShow, rejectInvoiceApply, revokeInvoiceApply, updateInvoiceTime, delInvoiceRecordApplyNoBill, invoiceApplyDeleteYsBillList,
  findWayBusinessListTotal } from '@/api/newTMS'
import { getCurrUserDepartment, getCurrUserCompany } from '@/api/newCrm'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import PLkiapiao from '@/views/newTMS/transportation/caiWuManage/fapiaoGuanli/PLkiapiao.vue'
import WZDkaipiao from './WZDkaipiao.vue'
import guanlianzhangdan from './guanlianzhangdan.vue'
import SearchCollapse from '@/components/common/SearchCollapse.vue'
export default {
  components: {
    uploadFiles, uploadImgs, PLkiapiao, WZDkaipiao, guanlianzhangdan, SearchCollapse
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      bumenList: [],
      kpsjFlag: false,
      kpsjForm: {},
      rules: {
        arrivalTime: [
          { required: true, message: '请选择开票时间', trigger: 'blur' }
        ],
        rejectionRemark: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ],
        invoiceNo: [
          { required: true, message: '请输入发票号码', trigger: 'blur' }
        ],
        fpje: [
          { required: true, message: '请输入发票金额', trigger: 'blur' }
        ],
        invoiceTime: [
          { required: true, message: '请选择开票时间', trigger: 'blur' }
        ]
      },
      BHform: {},
      BHflag: false,
      YDXQmark: false,
      yunDanList: [],
      kaiPiaoMark: false,
      kaiPiaoFrom: {

      },
      lookimgList: [],
      imgList: [],
      FJflag: false,
      RWMimgList: [],
      imgUrl: '',
      fujianList: [],
      SQfujianList: [],
      lookImgFlag: false,
      plkpFlag: false, // 批量开票
      moban: '发票二维码（有销售方）',
      zigongsiList: [],
      isDisable: false,
      wzdkpFlag: false,
      glzdFlag: false,
      rowData: {},
      YWLXlist: [],
      yewuliexing: '',
      summaryData: [],
      btnFlg: [],
      btnIdArr: ['01N0160100', '01N0160200', '01N0160300', '01N0160400', '01N0160500', '01N0160600', '01N0160700', '01N0160800',
        '01N0160900', '01N0160A00', '01N0160B00', '01N0160C00', '01N0160D00']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/fapiaoGuanli')
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getCurrUserCompany().then(res => { this.zigongsiList = res })
    // getCurrUserDepartment().then(res => { this.bumenList = res })
    this.getList()
  },
  mounted () {
    this.getHeight()
  },
  methods: {
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 170) + 'px'
      })
    },
    // 撤销关联
    cxglFN (row) {
      this.$confirm('是否执行撤销关联操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        invoiceApplyDeleteYsBillList({ id: row.id }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '撤销成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 无账单开票删除
    wzdDelFn (row) {
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delInvoiceRecordApplyNoBill({ id: row.id }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '撤销成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 关联账单
    glzdFN (row) {
      this.glzdFlag = true
      this.rowData = { ...row }
    },
    // 无账单开票
    wzdkpFn () {
      this.wzdkpFlag = true
    },
    // 导出
    async exportFn () {
      this.isDisable = true
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      await exportExcel(
        this.global.tmsPlus + '/settlementBill/exportInvoiceRecordApply',
        form,
        '发票管理'
      )
      this.isDisable = false // 点击一次时隔两秒后才能再次点击
    },
    // 子公司更改
    zigsChangeCX (e) {
      let json1 = this.zigongsiList.filter(item => item.companyName == e)
      getCurrUserDepartment({ compayCode: json1[0].companyCode }).then(res => { this.bumenList = res })
      this.$set(this.searchFrom, 'createSubdepartmentName', '')
    },
    // 批量开票
    plkpFn () {
      this.plkpFlag = true
    },
    YDsearchFn () {
      findWayBusinessList({
        wayBusinessTypeName: this.yewuliexing,
        applyId: this.rowData.id// 结算记录主表id
      }).then(res => {
        this.yunDanList = res
        this.hejiFn()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    getSummary (param) {
      return this.summaryData || [] // 若接口数据未加载，返回空数组避免报错
    },
    // 点击流水号
    detilsFn (row) {
      this.rowData = row
      findWayBusinessList({
        applyId: this.rowData.id// 结算记录主表id
      }).then(res => {
        this.yunDanList = res
        this.hejiFn()
        this.YDXQmark = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    hejiFn () {
      findWayBusinessListTotal({
        wayBusinessTypeName: this.yewuliexing,
        applyId: this.rowData.id// 结算记录主表id
      }).then(res => {
        this.summaryData = [
          '合计',
          '',
          '',
          res.liquidatedAmountSum,
          '',
          '',
          '',
          res.incomeAmountSum,
          res.revenueSurchargeSum,
          res.grossRevenueSum,
          res.ysPaymentAmountSum,
          res.ysNoPaymentAmountSum,
          res.ysInvoiceAmountSum,
          res.ysNoInvoiceAmountSum,
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ]
      })
    },
    // 附件
    fujianFN (row) {
      getFileShow({ businessId: row.id, businessType: 'invoiceRecordApplyQr' }).then(res => {
        this.RWMimgList = []
        res.forEach(item => {
          this.RWMimgList.push(item.fileKeyUrl)
        })
      })
      getFileShow({ businessId: row.id, businessType: 'invoiceRecordApply' }).then(res => {
        this.fujianList = []
        res.forEach(item => {
          var filename = item.url.split('/').pop()
          this.fujianList.push({
            name: filename,
            url: item.fileKeyUrl,
            isImg: this.isImage(filename)
          })
        })
        this.FJflag = true
      })
      getFileShow({ businessId: row.id, businessType: 'invoiceRecordApplySq' }).then(res => {
        this.SQfujianList = []
        res.forEach(item => {
          var filename = item.url.split('/').pop()
          this.SQfujianList.push({
            name: filename,
            url: item.fileKeyUrl,
            isImg: this.isImage(filename)
          })
        })
        this.FJflag = true
      })
    },
    fujianClick (row) {
      if (this.isImage(row.name)) {
        this.lookImgFlag = true
        this.imgUrl = row.url
      } else {
        window.open(row.url)
      }
    },
    isImage (filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      return imageExtensions.includes(extension)
    },
    // 二维码添加
    addRWMFn () {
      if (this.kaiPiaoFrom.ewmList.length == 10) {
        this.$alert('最多只能添加10条发票二维码', '系统提示')
        return
      }
      this.kaiPiaoFrom.ewmList.push({
        lookimgList: [],
        key: this.kaiPiaoFrom.ewmList[this.kaiPiaoFrom.ewmList.length - 1].key + 1
      })
    },
    // 二维码删除
    delewmFn (index) {
      if (this.kaiPiaoFrom.ewmList.length == 1) {
        this.$alert('已经是最后一条数据了，不能删除', '系统提示')
        return
      }
      console.log(this.kaiPiaoFrom.ewmList)
      this.deleteImage(this.kaiPiaoFrom.ewmList[index].lookimgList[0])
      this.kaiPiaoFrom.ewmList.splice(index, 1)
    },
    deleteImage () {

    },
    // 开票
    kaipiaoFn (row) {
      this.kaiPiaoFrom = {}
      this.kaiPiaoFrom.id = row.id
      this.kaiPiaoFrom.invoiceAmount = row.pendingAmount / 100
      this.$set(this.kaiPiaoFrom, 'invoiceTime', new Date().getTime())
      this.$set(this.kaiPiaoFrom, 'ewmList', [{ lookimgList: [], key: 0 }])
      this.$set(this.kaiPiaoFrom, 'rejectionTime', row.rejectionTime)
      if (this.$refs.kaiPiaoFrom) {
        this.$refs.kaiPiaoFrom.resetFields()
      }

      this.kaiPiaoMark = true
    },
    kaiPiaoSubmitFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let flag = this.kaiPiaoFrom.ewmList.every(itme => itme.lookimgList.length != 0)
          if (!flag) {
            this.$alert('请上传发票二维码', '系统提示')
            return
          }
          let nowtime = new Date().getTime()
          const fourHoursMs = 4 * 60 * 60 * 1000
          if (nowtime - this.kaiPiaoFrom.rejectionTime > fourHoursMs) {
            this.$confirm('开票上传时间与通过时间间隔已大于4小时，是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.dierictishi()
            }).catch(() => {

            })
          } else {
            this.dierictishi()
          }
        } else {
          return false
        }
      })
    },
    dierictishi () {
      let allje = 0
      this.kaiPiaoFrom.ewmList.forEach(item => {
        allje += Number(item.fpje)
      })
      allje = toFixed(allje, 2)
      if (allje != toFixed(this.kaiPiaoFrom.invoiceAmount, 2)) {
        this.$confirm('发票金额不匹配是否继续开票?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.jiekou()
        }).catch(() => {

        })
      } else {
        this.jiekou()
      }
    },
    jiekou () {
      let imgfile = new FormData()
      let fphmARR = []
      this.kaiPiaoFrom.ewmList.forEach(item => {
        imgfile.append('filesQr ', item.lookimgList[0].raw)
        fphmARR.push(item.fphm)
      })
      this.imgList.forEach(item => {
        imgfile.append('files', item.raw)
      })
      this.$set(this.kaiPiaoFrom, 'invoiceNo', fphmARR.toString())
      imgfile.set('params', JSON.stringify(this.kaiPiaoFrom))
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      confirmInvoiceApply(imgfile).then(res => {
        this.getList(this.searchFrom)
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.kaiPiaoMark = false
        loading.close()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 上传二维码图片
    change (fileList, index) {
      if (fileList.length > 0) {
        ocrModelList({ labelList: ['唐山曹妃甸兴瀚钢铁物流有限公司'], modelName: this.moban }).then(res => {
          let Id = JSON.parse(res)[0].id
          let imgfile = new FormData()
          imgfile.set('params', JSON.stringify({ modelId: Id }))
          imgfile.append('file', fileList[0].raw)
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          ocrCustomModelByFile(imgfile).then(res => {
            loading.close()
            let data = JSON.parse(res)
            console.log(data)
            this.$set(this.kaiPiaoFrom.ewmList[index], 'fphm', data.invoiceNo)
            data.invoiceAmount = data.invoiceAmount.replace(/[^\d\.]/g, '')
            this.$set(this.kaiPiaoFrom.ewmList[index], 'fpje', data.invoiceAmount)
            // if (data.invoiceAmount != this.kaiPiaoFrom.invoiceAmount) {
            //   this.$alert('发票信息与申请流水信息不一致', '系统提示')
            // }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(error => {
          this.$message.error(error.message)
        })
      }
    },
    // 撤销开票
    chexiaoKPFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].status != 1) {
        this.$alert('只能选择开票状态为已开票的数据', '系统提示')
        return
      }
      this.$confirm('是否执行撤销申请操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        revokeInvoiceApply({ id: selectData[0].id }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '撤销成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 撤销申请
    chexiaoSQFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].billInvoiceFlag == 1) {
        this.$alert('无账单开票类型不可操作', '系统提示')
        return
      }
      if (selectData[0].status !== 0) {
        this.$alert('只能选择开票状态为待开票的数据', '系统提示')
        return
      }
      this.$confirm('是否执行撤销申请操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delInvoiceRecordApply({ id: selectData[0].id }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '撤销成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 删除
    delFN (row) {
      this.$confirm('是否执行删除申请操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        delInvoiceRecordApply({ id: row.id }).then(res => {
          this.getList(this.searchFrom)
          this.$message({
            message: '撤销成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 修改开票时间
    xgkpsjFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let flag = selectData.every(item => item.status == 1)
      if (!flag) {
        this.$alert('只能选择已开票的数据', '系统提示')
        return
      }
      let arr = selectData.map(item => item.id)
      this.kpsjForm.ids = arr.toString()
      this.kpsjFlag = true
    },
    KPSJsaveFn () {
      this.$refs.kpsjForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateInvoiceTime(this.kpsjForm).then(res => {
            loading.close()
            this.kpsjFlag = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 通过
    tongguoFn (row) {
      this.$confirm('是否审核通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        rejectInvoiceApply({ id: row.id, auditStatus: 1 }).then(res => {
          this.getList(this.searchFrom)
          this.YDXQmark = false
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    bohuiFn (row) {
      this.BHflag = true
      this.BHform = {}
      this.BHform.id = row.id
      this.BHform.auditStatus = 2
    },
    BHsaveFn () {
      this.$refs.BHform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          rejectInvoiceApply(this.BHform).then(res => {
            loading.close()
            this.BHflag = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
            this.YDXQmark = false
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 复制
    copyBtn (message) {
      // navigator.clipboard.writeText 该方法需要在安全域下才能够使用，比如：https 协议的地址、127.0.0.1、localhost
      navigator.clipboard
        .writeText(message)
        .then(() => {
          this.$message.success('复制成功')
        }).catch((err) => {
        })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
      that.weight = that.weight.toFixed(3)
      this.num = selection.length
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      // if (this.searchFrom.sqls) {
      //   let sqls = this.searchFrom.sqls.replace(/\n/g, ',')
      //   let sqlsArr = sqls.split(',')
      //   if (sqlsArr.length == 1) {
      //     this.searchFrom.applyNo = sqlsArr[0]
      //   } else {
      //     this.searchFrom.applyNos = sqlsArr
      //   }
      // } else {
      //   this.searchFrom.applyNos = null
      //   this.searchFrom.applyNo = ''
      // }
      if (this.searchFrom.sqls) {
        this.searchFrom.applyNo = this.searchFrom.sqls.trim().replace(/\n/g, ',')
      } else {
        this.searchFrom.applyNo = ''
      }
      if (this.searchFrom.ydh) {
        this.searchFrom.wayNo = this.searchFrom.ydh.trim().replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNo = ''
      }
      if (this.searchFrom.createTime) {
        this.searchFrom.createTimeStart = this.searchFrom.createTime[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTime[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.invoiceTime) {
        this.searchFrom.invoiceTimeStart = this.searchFrom.invoiceTime[0]
        this.searchFrom.invoiceTimeEnd = this.searchFrom.invoiceTime[1]
      } else {
        this.searchFrom.invoiceTimeStart = ''
        this.searchFrom.invoiceTimeEnd = ''
      }
      this.loading = true
      getInvoiceRecordApplyList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 430px!important;
}
/deep/.el-form{
  width: 100%;
}
.kaip /deep/.el-form-item--small .el-form-item__content{
  width:200px;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 280px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
.imgBox{
  margin: 7px 0px;
  /deep/.el-upload--picture-card{
    width: 200px;
    height: 200px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
     width: 200px;
    height: 200px;
  }
}
.fujianBox{
  .el-image{
    height: 50px;
      width: 100%;
      margin-bottom: 6px;
  }
}
</style>
